import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Modal, Typography } from '@material-ui/core'
import { useTranslation } from '../../contexts/i18n/use'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { ConfirmationItem } from './confirmationitem'

export const Confirmation = ({items, cancel, confirm}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t, dt}} = useTranslation();

  return (
    <Dialog 
      open={true} 
      classes={{paper: classes.modal}}
      className="formspage-confirmation-root"
      >
      <DialogTitle>{ t('formspage.confirmation.title')}</DialogTitle>
      <DialogContent id="ticket-cancelticket-dialog-content-id">
        { items ? items.map(x => {return <ConfirmationItem head={x.label} body={x.value} />}): <span/>}
      </DialogContent>
      <DialogActions className={classes.buttonwrapper}>
        <Button className={[classes.cancelbutton, "dialogbutton"].join(' ')} id="ticket-cancelticket-recline-button-id" onClick={x => cancel()}>
          <Typography id="ticket-cancelticket-recline-button-text-id">
            { t('formspage.confirmation.cancel')}
          </Typography>
        </Button>
        <Button className={[classes.confirmbutton, "dialogbutton"].join(' ')} id="ticket-cancelticket-confirm-button-id" onClick={x => confirm()}>
          <Typography id="ticket-cancelticket-confirm-button-text-id">
            { t('formspage.confirmation.confirm')}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const useStyles = makeStyles({
  modal: theme => ({
    border: '1px solid '+ theme.palette.primary.main,
    alignItems: 'center'
  }),
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%'
  },
  confirmbutton: theme => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.button_text.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  cancelbutton: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.button_text.main,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.info.main,
        color: theme.palette.button_text.main
      }
    }
  })
})